<app-navigation-header title="Billing" i18n-title="@@billingMaintab-Billing">
	<app-billing-list-table [appBreadcrumbLabel]="billingListBreadcrumbLabel"></app-billing-list-table>
</app-navigation-header>
